import React, { useState } from 'react';
import PropTypes from 'prop-types';

import AuthBody from '../AuthBody';
import AuthBodyTitle from '../AuthBodyTitle';
import AuthBodyButton from '../AuthBodyButton';
import AuthBodyContent from '../AuthBodyContent';
import AuthBodyConfirmation from '../AuthBodyConfirmation';
import AuthBodyAlert from '../AuthBodyAlert';
import { Link } from '@material-ui/core';

const propTypes = {
    confirmEmail: PropTypes.string.isRequired
};

function SentEmailBody ({ confirmEmail }) {
    const authenticity_token = document.querySelector('meta[name=\'csrf-token\']').getAttribute('content');

    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    function resendConfirmation (e) {
        const searchParams = new URLSearchParams({
            authenticity_token: authenticity_token,
            utf8: '✓',
            'user[email]': confirmEmail,
            commit: 'RESEND confirmation instructions'
        });
        fetch('/user/confirmation', {
            method: 'POST',
            body: searchParams.toString(),
            headers: {
                'content-type': 'application/x-www-form-urlencoded'
            }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    setMessage(data.message);
                } else {
                    setError('An error occurred while sending confirmation instructions. Please try again.' );
                }
            })
            .catch((err) => {
                setError('An error occurred while sending confirmation instructions. Please try again.');
            });
    }

    return (
        <AuthBody>
            <AuthBodyTitle>
                Please confirm your email
            </AuthBodyTitle>
            { message && <AuthBodyAlert severity="success" >{ message }</AuthBodyAlert> }
            { error && <AuthBodyAlert severity="error" >{ error }</AuthBodyAlert> }
            <AuthBodyContent>
                We sent a confirmation email to <strong>{confirmEmail}</strong>
                <br />
                <br />
                Please follow the instructions to finish setting up your account
            </AuthBodyContent>
            <AuthBodyConfirmation
                linkText="Resend confirmation request"
                href="#"
                onLinkClick={resendConfirmation}
            >
                Didn't recieve an email?
            </AuthBodyConfirmation>
            <Link href="/user/login">
                <AuthBodyButton>
                    Back to login
                </AuthBodyButton>
            </Link>
        </AuthBody>
    );
}

SentEmailBody.propTypes = propTypes;

export default SentEmailBody;